import { render, staticRenderFns } from "./detailMaterial.vue?vue&type=template&id=7dd29611&"
import script from "./detailMaterial.vue?vue&type=script&lang=js&"
export * from "./detailMaterial.vue?vue&type=script&lang=js&"
import style0 from "./detailMaterial.vue?vue&type=style&index=0&id=7dd29611&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd29611')) {
      api.createRecord('7dd29611', component.options)
    } else {
      api.reload('7dd29611', component.options)
    }
    module.hot.accept("./detailMaterial.vue?vue&type=template&id=7dd29611&", function () {
      api.rerender('7dd29611', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/detailMaterial.vue"
export default component.exports